import styled, { css } from "styled-components"
import FormGroup from "./FormGroup"

export const inputStyles = css`
  outline: 0;
  margin-bottom: 10px;
  padding: 8px 10px;
  border: none;
  height: 30px;
  width: 100%;
  color: ${props => props.theme.color.text};
  background-color: ${props => props.theme.color.borderLight};
`

const PageForm = styled.div`
  & ${FormGroup} {
    margin-bottom: 0;
    position: relative;

    label {
      position: relative;
      color: ${props => props.theme.color.label};
      font-size: ${props => props.theme.font.size.inputlabel};
    }

    input {
      ${inputStyles}
    }

    span {
      font-size: ${props => props.theme.font.size.inputlabel};
    }
  }
`

export default PageForm
